import { gql } from '@apollo/client/core';

export const htmlEmbedBlockFragment = gql`
  fragment HtmlEmbedBlockFields on HtmlEmbedBlock {
    entryTitle
    iFrameTitle
    htmlCode
    notes
  }
`;
